import { useState, useEffect } from "react";
import { Col, Row } from "reactstrap";
import SearchBox from "../components/SearchBox";
import SelectBox from "../components/SelectBox";
import { USER_STATUS } from "../utils/Constant";
import { useDispatch, useSelector } from 'react-redux';
import { getAllRoles } from '../api/roleMasterApi';
import { AppDispatch } from "../redux/store";
import { DEFAULT_OPTION } from "../utils/Constant";
import { UserAccessFilterType } from "../models/DashboardModels";

interface SelectOptionType {
    label: string;
    value: string;
}

interface UserAccessFilterProps {
    onApplyFilters: (viewFilter: UserAccessFilterType) => void;
}

const UserAccessFilters = ({
    onApplyFilters
}: UserAccessFilterProps) => {

    const [filters, setFilters] = useState<UserAccessFilterType>({
        email: "",
        role: DEFAULT_OPTION,
        status: DEFAULT_OPTION,
    });

    const onReset = () => {
        const resetFilters = {
            email: "",
            role: DEFAULT_OPTION,
            status: DEFAULT_OPTION,
        };
        setFilters(resetFilters);
        onApplyFilters(resetFilters);
    };

    const dispatch = useDispatch<AppDispatch>();
    const { storeAllRoles } = useSelector((state: any) =>
        state.roleMaster);

    useEffect(() => {
        dispatch(getAllRoles());
    }, [dispatch]);

    const roleOptions: SelectOptionType[] =
    storeAllRoles.map((role: any) => ({
        label: role.name,
        value: role.name,
    }));

    const statusOptions: SelectOptionType[] =
    Object.entries(USER_STATUS).map(
        ([label, value]) => ({
            label,
            value: value.toString(),
        })
    );
    
    return (
        <div className="border rounded ps-3 pt-2 pe-3 pb-3 mb-3">
            <Row className="mb-2">
                <Col xs={8} md={3}>
                    <SearchBox
                        label="Email"
                        placeHolder="Search by Email"
                        maxLength={50}
                        value={filters.email}
                        onChange={(e) => {
                            setFilters({
                                ...filters,
                                email: e.target.value,
                            });
                        }}
                    />            
                </Col>
                <Col xs={8} md={3}>
                    <SelectBox
                        label="Role"
                        value={filters.role}
                        options={roleOptions}
                        onChange={(event: any) => {
                            setFilters({
                                ...filters,
                                role: event,
                            });
                        }}
                    />            
                </Col>
            </Row>
            <Row>
                <Col xs={6} md={3} className="d-flex align-items-center mb-2 buttons-container">
                    <button className="button" onClick={() =>
                        onApplyFilters(filters)}>Search</button>
                    <button className="resetButton" onClick={onReset}>Reset</button>
                </Col>
            </Row>
        </div>
    );
};

export default UserAccessFilters;